export default "__VITE_ASSET__1cf04705__"